"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ipAddressHandler = void 0;
var HandlerMapping_1 = require("../handler/HandlerMapping");
function ipAddressHandler(data) {
    if (typeof data !== 'string') {
        return HandlerMapping_1.HandlerMapping.handlersMapping.default();
    }
    // eslint-disable-next-line no-useless-escape
    return data.replace(/[^\.\s]/g, '*');
}
exports.ipAddressHandler = ipAddressHandler;
//# sourceMappingURL=ipAddressHandler.js.map